import { apiRequest, getStoredUser, saveSession } from "./apiClient";
import { emitRestDataChanged } from "./restEventBus";
import { trackEngagementDataAdded } from "./engagementService";
import { currentTimeZonePayload } from "../hooks/useUserTimezone";

const enc = (v) => encodeURIComponent(String(v || ""));

const emitResponseChanges = (familyId, changes = []) => {
  changes.forEach((change) => {
    emitRestDataChanged({ familyId, ...change });
    if (change.resource === "familyMembers" && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("fp:familyPermissionsChanged", { detail: { familyId } }));
    }
  });
};

export const saglikKayitlariGetirService = async (familyId) => {
  if (!familyId) return [];
  const data = await apiRequest(`/health-records/${enc(familyId)}`);
  return Array.isArray(data?.records) ? data.records : [];
};

export const saglikKaydiEkleService = async ({ familyId, payload }) => {
  const data = await apiRequest(`/health-records/${enc(familyId)}`, {
    method: "POST",
    body: JSON.stringify({ ...(payload || {}), timeZone: currentTimeZonePayload().timeZone }),
  });
  const record = data?.record || null;
  trackEngagementDataAdded({ familyId, moduleKey: "health", itemId: record?.id || record?.firebaseId });
  if (Array.isArray(data?.changes)) emitResponseChanges(familyId, data.changes);
  else emitRestDataChanged({ familyId, resource: "health", action: "added", item: record });
  emitRestDataChanged({ familyId, resource: "calendar", action: "refresh" });
  emitRestDataChanged({ familyId, resource: "tasks", action: "refresh" });
  return record;
};

export const saglikKaydiGuncelleService = async ({ familyId, recordId, payload }) => {
  const data = await apiRequest(`/health-records/${enc(familyId)}/${enc(recordId)}`, {
    method: "PUT",
    body: JSON.stringify({ ...(payload || {}), timeZone: currentTimeZonePayload().timeZone }),
  });
  const record = data?.record || null;
  if (Array.isArray(data?.changes)) emitResponseChanges(familyId, data.changes);
  else emitRestDataChanged({ familyId, resource: "health", action: "updated", item: record });
  emitRestDataChanged({ familyId, resource: "calendar", action: "refresh" });
  emitRestDataChanged({ familyId, resource: "tasks", action: "refresh" });
  return record;
};

export const saglikKaydiSilService = async ({ familyId, recordId }) => {
  const data = await apiRequest(`/health-records/${enc(familyId)}/${enc(recordId)}`, { method: "DELETE" });
  if (Array.isArray(data?.changes)) emitResponseChanges(familyId, data.changes);
  else emitRestDataChanged({ familyId, resource: "health", action: "deleted", itemId: recordId });
  emitRestDataChanged({ familyId, resource: "calendar", action: "refresh" });
  emitRestDataChanged({ familyId, resource: "tasks", action: "refresh" });
  return data;
};

export const kendiSaglikProfiliniGuncelleService = async ({ familyId, healthProfile, memberName, fieldKey, date }) => {
  const data = await apiRequest(`/health-records/${enc(familyId)}/profile`, {
    method: "PATCH",
    body: JSON.stringify({ healthProfile: healthProfile || {}, memberName, fieldKey, date }),
  });
  emitResponseChanges(familyId, Array.isArray(data?.changes) ? data.changes : [{ resource: "familyMembers", action: "refresh" }]);
  const storedUser = getStoredUser() || {};
  const nextHealthProfile = data?.healthProfile || healthProfile || {};
  const user = {
    ...storedUser,
    healthProfile: nextHealthProfile,
    profil: { ...(storedUser.profil || {}), healthProfile: nextHealthProfile },
  };
  saveSession({ user });
  return user;
};
